import { ref } from "vue";
import type { HomepageBlockKind } from "@/services/homepage";

// Module-level singleton: the Home view publishes its customize state here so
// the sidepanel's Blocks tab (rendered far away in the chrome) can show
// on-page markers and add blocks.
const onPageKinds = ref<HomepageBlockKind[]>([]);
const addHandler = ref<((kind: HomepageBlockKind) => void) | null>(null);

export function useHomeBlockLibrary() {
  return { onPageKinds, addHandler };
}
